import { Injectable, signal } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { BankAccountKycDialogResult } from '../../components/app-layout/shared/bank-account-kyc-dialog/bank-account-kyc-dialog.component';

@Injectable({ providedIn: 'root' })
export class BankAccountKycDialogStateService {
    readonly open = signal(false);

    private _result$: Subject<BankAccountKycDialogResult> | null = null;

    ask(): Observable<BankAccountKycDialogResult> {
        this.answer({ startVerification: false });
        this._result$ = new Subject<BankAccountKycDialogResult>();
        this.open.set(true);

        return this._result$.asObservable();
    }

    answer(result: BankAccountKycDialogResult): void {
        const result$ = this._result$;
        this._result$ = null;
        this.open.set(false);
        result$?.next(result);
        result$?.complete();
    }
}
